import loadable from '@loadable/component';

export const CombinedResultCard = loadable(() => import('./CombinedResultCard'), {
  resolveComponent: (m) => m.CombinedResultCard,
});
